export const basename = '/favorites';

export const paths = {
    VIEWED: '/viewed/',
    ITEMS: '/items/',
    FOLDER: '/folders/:folderUrlLabel/:folderId/',
    FOLDER_SHARED: '/folders/:folderId/',
    FOLDERS: '/folders/',
    PROJECTS: '/projects/',
    PROJECT: '/project/:projectId/:folderId/',
    FOLLOWING: '/following/',
    DISCOVER: '/discover/',
    CURATED_FOLDERS: '/selections/',
    CURATED_FOLDER: '/selections/:folderUrlLabel/:folderId/',
};

export const sortBy = {
    ALPHABETICAL: 'ALPHABETICAL',
    MODIFIED: 'MODIFIED',
    CUSTOM: 'CUSTOM',
    RECENTLY_CREATED: 'RECENTLY_CREATED',
    RECENTLY_MODIFIED: 'RECENTLY_MODIFIED',
    PRICE_ASC: 'PRICE_ASC',
    PRICE_DESC: 'PRICE_DESC',
};

export const MODIFY_PORTFOLIO_ACTIONS = {
    ADD: 'ADD',
    EDIT: 'EDIT',
    REMOVE: 'REMOVE',
    REORDER: 'REORDER',
};

export const viewModes = {
    LIST: 'LIST',
    GRID: 'GRID',
};

export const pageSize = 60;

export const initialState = {
    first: pageSize,
    page: 1,
    sortBy: sortBy.CUSTOM,
    isReordering: false,
    selectedItems: [],
    isSelecting: false,
    isSharedPortfolio: false,
    searchTerm: '',
    viewMode: viewModes.GRID,
    selectAll: false,
    isRefetching: false,
    isClient: false,
    tab: null,
    openConfirmationModal: {
        modalType: null,
        isError: false,
    },
};

export const MODAL_TYPES = {
    ADD_ITEMS: 'ADD_ITEMS',
    DELETE_ITEMS: 'DELETE_ITEMS',
    ADD_NOTE: 'ADD_NOTE',
    DELETE_NOTE: 'DELETE_NOTE',
    CREATE_FOLDER: 'CREATE_FOLDER',
    DELETE_FOLDER: 'DELETE_FOLDER',
    DELETE_FOLLOWING: 'DELETE_FOLLOWING',
};

export const PAGINATION_SIZES = {
    DESKTOP: 9,
    MOBILE: 6,
};

export const SEARCH_PARAMS = {
    PAGE: 'page',
    SEARCH: 'search',
    SORT: 'sort',
};

export const privacySettings = {
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
};

export const portfolioTypes = {
    FOLDER: 'FOLDER',
    ITEMS: 'HEART',
    PROJECT: 'PROJECT',
};

export const tabs = {
    DISCOVER: 'discover',
    FOLDER: 'folder',
    FOLDERS: 'folders',
    FOLLOWING: 'following',
    ITEMS: 'items',
    PROJECT: 'project',
    PROJECTS: 'projects',
    VIEWED: 'viewed',
    CURATED_FOLDER: 'selections-folder',
    CURATED_FOLDERS: 'selections',
};

export const trackingLists = {
    [tabs.ITEMS]: 'Favorites|items',
    [tabs.FOLDER]: 'Favorites|folders',
    [tabs.FOLLOWING]: 'Favorites|following',
    [tabs.VIEWED]: 'Favorites|viewed',
    [tabs.CURATED_FOLDER]: 'Favorites|curated folders',
};

export const CALLOUT_TYPES = {
    EDIT_FOLDER: 'editFolder',
    REARRANGE_ITEMS: 'rearrangeItems',
    NEW_DISCOVERY_FEED: 'newDiscoveryFeed',
};

export const followingTypes = {
    SEARCH: 'SEARCH',
    SELLER: 'SELLER',
    DESIGNER: 'DESIGNER',
    USER_PREFERENCE: 'USER_PREFERENCE',
};

export const favoriteParameters = {
    // Parameter Keys
    keys: {
        KEY_QUERY: 'query',
        KEY_CATEGORY: 'category',
        KEY_CATEGORY_L2: 'category_l2',
        KEY_PRICE: 'price',
        KEY_CURRENCY: 'currency',
        KEY_PERIOD: 'period',
        KEY_CREATOR: 'creator',
        KEY_LOCATION: 'location',
        KEY_ASSOCIATION: 'association',
        KEY_COLLECTION: 'collection',
        KEY_HEIGHT: 'height',
        KEY_WIDTH: 'width',
        KEY_LENGTH: 'length',
        KEY_SECTION_FURNITURE: 'furniture_section',
        KEY_SECTION_FASHION: 'fashion_section',
        KEY_SECTION_JEWELRY: 'jewelry_section',
        KEY_GENDER: 'gender',
        KEY_ORIGIN: 'origin',
        KEY_MATERIAL: 'material',
        KEY_METAL: 'metal',
        KEY_DEALER: 'dealer',
        KEY_SHIPPING: 'shipping',
        KEY_SOLD: 'sold',
        KEY_STONE: 'stone',
        KEY_STYLE: 'style',
        KEY_TECHNIQUE: 'technique',
        KEY_ITEM_COUNT: 'item_count',
        KEY_NEW_ITEM_COUNT: 'new_item_count',
        KEY_COLOR: 'color',
        KEY_STONE_CUT: 'stone-cut',
    },
    // Parameter Display Text
    displays: {
        DISPLAY_QUERY: 'Search Term',
        DISPLAY_CATEGORY: 'Category',
        DISPLAY_PRICE: 'Price',
        DISPLAY_CURRENCY: 'Currency',
        DISPLAY_PERIOD: 'Period',
        DISPLAY_CREATOR: 'Creator',
        DISPLAY_LOCATION: 'Location',
        DISPLAY_ASSOCIATION: 'Association',
        DISPLAY_COLLECTION: 'Collection',
        DISPLAY_HEIGHT: 'Height',
        DISPLAY_WIDTH: 'Width',
        DISPLAY_LENGTH: 'Length',
        DISPLAY_SECTION_FURNITURE: 'Section',
        DISPLAY_SECTION_FASHION: 'Section',
        DISPLAY_SECTION_JEWELRY: 'Section',
        DISPLAY_GENDER: 'Gender',
        DISPLAY_ORIGIN: 'Origin',
        DISPLAY_MATERIAL: 'Material',
        DISPLAY_METAL: 'Metal',
        DISPLAY_DEALER: 'Dealer',
        DISPLAY_SHIPPING: 'Shipping',
        DISPLAY_SOLD: 'Show Sold',
        DISPLAY_STONE: 'Stone',
        DISPLAY_STYLE: 'Style',
        DISPLAY_TECHNIQUE: 'Technique',
        DISPLAY_NEW_ITEMS: 'New Items',
        DISPLAY_COLOR: 'Color',
        DISPLAY_STONE_CUT: 'Stone Cut',
    },
};

export const favoriteParametersMapping = {
    // Parameters lists
    lists: {
        // Keys whose values are numeric ranges
        NUMERIC_RANGE_KEYS: [
            favoriteParameters.keys.KEY_PRICE,
            favoriteParameters.keys.KEY_HEIGHT,
            favoriteParameters.keys.KEY_WIDTH,
        ],
        // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
        // Categories that use length instead of height for dimensions
        SHOW_LENGTH_CATEGORIES: ['Rugs and Carpets', 'Rugs'],
        // Keys with values that need to be pre-processed
        PRE_PROCESS_KEYS: [favoriteParameters.keys.KEY_SOLD],
    },
    // Map key to display text
    DISPLAY_MAP: {
        [favoriteParameters.keys.KEY_QUERY]: favoriteParameters.displays.DISPLAY_QUERY,
        [favoriteParameters.keys.KEY_CATEGORY]: favoriteParameters.displays.DISPLAY_CATEGORY,
        [favoriteParameters.keys.KEY_PRICE]: favoriteParameters.displays.DISPLAY_PRICE,
        [favoriteParameters.keys.KEY_CURRENCY]: favoriteParameters.displays.DISPLAY_CURRENCY,
        [favoriteParameters.keys.KEY_PERIOD]: favoriteParameters.displays.DISPLAY_PERIOD,
        [favoriteParameters.keys.KEY_CREATOR]: favoriteParameters.displays.DISPLAY_CREATOR,
        [favoriteParameters.keys.KEY_LOCATION]: favoriteParameters.displays.DISPLAY_LOCATION,
        [favoriteParameters.keys.KEY_ASSOCIATION]: favoriteParameters.displays.DISPLAY_ASSOCIATION,
        [favoriteParameters.keys.KEY_COLLECTION]: favoriteParameters.displays.DISPLAY_COLLECTION,
        [favoriteParameters.keys.KEY_HEIGHT]: favoriteParameters.displays.DISPLAY_HEIGHT,
        [favoriteParameters.keys.KEY_WIDTH]: favoriteParameters.displays.DISPLAY_WIDTH,
        [favoriteParameters.keys.KEY_LENGTH]: favoriteParameters.displays.DISPLAY_LENGTH,
        [favoriteParameters.keys.KEY_SECTION_FURNITURE]:
            favoriteParameters.displays.DISPLAY_SECTION_FURNITURE,
        [favoriteParameters.keys.KEY_SECTION_FASHION]:
            favoriteParameters.displays.DISPLAY_SECTION_FASHION,
        [favoriteParameters.keys.KEY_SECTION_JEWELRY]:
            favoriteParameters.displays.DISPLAY_SECTION_JEWELRY,
        [favoriteParameters.keys.KEY_GENDER]: favoriteParameters.displays.DISPLAY_GENDER,
        [favoriteParameters.keys.KEY_ORIGIN]: favoriteParameters.displays.DISPLAY_ORIGIN,
        [favoriteParameters.keys.KEY_MATERIAL]: favoriteParameters.displays.DISPLAY_MATERIAL,
        [favoriteParameters.keys.KEY_METAL]: favoriteParameters.displays.DISPLAY_METAL,
        [favoriteParameters.keys.KEY_DEALER]: favoriteParameters.displays.DISPLAY_DEALER,
        [favoriteParameters.keys.KEY_SHIPPING]: favoriteParameters.displays.DISPLAY_SHIPPING,
        [favoriteParameters.keys.KEY_SOLD]: favoriteParameters.displays.DISPLAY_SOLD,
        [favoriteParameters.keys.KEY_STONE]: favoriteParameters.displays.DISPLAY_STONE,
        [favoriteParameters.keys.KEY_STYLE]: favoriteParameters.displays.DISPLAY_STYLE,
        [favoriteParameters.keys.KEY_TECHNIQUE]: favoriteParameters.displays.DISPLAY_TECHNIQUE,
        [favoriteParameters.keys.KEY_NEW_ITEM_COUNT]: favoriteParameters.displays.DISPLAY_NEW_ITEMS,
        [favoriteParameters.keys.KEY_COLOR]: favoriteParameters.displays.DISPLAY_COLOR,
        [favoriteParameters.keys.KEY_STONE_CUT]: favoriteParameters.displays.DISPLAY_STONE_CUT,
    },
    PRE_PROCESS_DISPLAY_MAP: {
        true: 'Yes',
        false: 'No',
    },
};
